import { TextField, InputAdornment } from '@mui/material';
import InputMask from 'react-input-mask';

const FormField = ({
  name,
  label,
  icon,
  errorMessage,
  value,
  onChange,
  mask,
  darkBackground = false,
  ...otherProps
}) => {
  const TextFieldComponent = (inputProps = {}) => (
    <TextField
      {...inputProps}
      fullWidth
      name={name}
      label={label}
      error={!!errorMessage}
      helperText={errorMessage}
      variant="outlined"
      slots={{
        input: undefined,
      }}
      slotProps={{
        root: {
          sx: {
            backgroundColor: (theme) => theme.palette.grey[50],
            borderRadius: '8px',
            '& .MuiOutlinedInput-root': {
              padding: 0,
              borderRadius: '8px',
              height: '45px',
              '& fieldset': { border: 'none' },
              '&:hover fieldset': { border: 'none' },
              '&.Mui-focused fieldset': { border: 'none' },
            },
          },
        },
        input: {
          sx: {
            padding: '0 14px',
            height: '45px',
            lineHeight: '45px',
            boxSizing: 'border-box',
            color: 'black',
          },
          startAdornment: icon ? (
            <InputAdornment position="start">
              <img src={icon} alt="icon" style={{ height: 24 }} />
            </InputAdornment>
          ) : undefined,
        },
        inputLabel: {
          sx: {
            color: (theme) => theme.palette.primary.main,
            paddingLeft: '14px',
            top: '50%',
            transform: 'translateY(-50%)',
            transition: 'all 0.3s ease',
            // Quando a label sobe, ela sai de dentro do campo (claro) e vai
            // para cima do fundo. Em formulários sobre o card azul (login,
            // cadastro etc.) ela precisa ser branca; nos demais, mantém o azul.
            '&.MuiInputLabel-shrink': {
              top: -22,
              transform: 'none',
              color: (theme) => (darkBackground ? 'white' : theme.palette.primary.main),
            },
            '&.Mui-focused': {
              color: (theme) => (darkBackground ? 'white' : theme.palette.primary.dark),
            },
          },
        },
      }}
    />
  );

  // Return masked or unmasked input based on mask prop
  return mask ? (
    <InputMask
      value={value}
      onChange={onChange}
      mask={mask}
      maskChar=" "
      {...otherProps}
    >
      {(inputProps) => TextFieldComponent(inputProps)}
    </InputMask>
  ) : (
    TextFieldComponent({ value, onChange, ...otherProps })
  );
};

export default FormField;
